import React, { useEffect, useContext } from 'react';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import RangeInputNumber from '../../molecules/Range/RangeInputNumber';
import Radio from '@material-ui/core/Radio';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TFunction, useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';
import { FFT_MAX_VALUE_ONPRE, FFT_MAX_VALUE_CLUDO } from '../../../Constant';

const useStyles = makeStyles(
  createStyles({
    tableStyle: {
      fontSize: '13px',
    },
    labelStyle: {
      fontSize: '13px',
    },
    itemBoxStyle: {
      fontSize: '13px',
    },
  })
);

export type RangeType = {
  id: number;
  min: number;
  max: number;
  splitsCount: number;
};

export type RangeSelectDataType = {
  rengeId: number;
  rengeMin: number;
  rengeMax: number;
  dbId: number;
  dbMin: number;
  dbMax: number;
  selectAxis: string;
  yMin: number; //Y軸設定最小値
  yMax: number; //Y軸設定最大値
  holdLinearValueMin: number;
  holdLinearValueMax: number;
  yUnit: string; //Y軸の範囲
};

//計測種別リスト作成
const createRengeList = (data: RangeType[], t: TFunction<'translation'>): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    for (var i in data) {
      ret.push({
        index: data[i].id,
        name: data[i].id === -1 ? t('FFTComparisonChartSetting.任意', '任意') : `${data[i].min} ~ ${data[i].max}`,
      });
    }
  }
  return ret;
};

type Props = {
  rangeSelectData: RangeSelectDataType;
  onChangeRangeSelectDataEvent: (selectData: RangeSelectDataType) => void;
};

const FFTComparisonChartSetting: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  console.debug('FFTComparisonChartSetting -- props', props);

  const [frequencyRangeList, setFrequencyRangeList] = React.useState<RangeType[]>([]);
  const [frequencyRengeCmd, setFrequencyRengeCmd] = React.useState<ComboBoxItemType[]>([]);

  const [dBRangeList, setdBRangeList] = React.useState<RangeType[]>([]);
  const [dBRangeCmd, setdBRangeCmd] = React.useState<ComboBoxItemType[]>([]);

  const [rangeSelectData, setRangeSelectData] = React.useState<RangeSelectDataType>(props.rangeSelectData);

  const [selectAxis, setSelectAxis] = React.useState('r');
  const { login } = useContext(AppContext);

  useEffect(() => {
    var dt: RangeType[] = [];
    dt.push({ id: 1, min: 0, max: 100, splitsCount: 10 });
    dt.push({ id: 2, min: 0, max: 500, splitsCount: 10 });
    dt.push({ id: 3, min: 0, max: 600, splitsCount: 10 });
    dt.push({ id: -1, min: 0, max: 0, splitsCount: 0 });
    setFrequencyRangeList(dt);
    setRangeSelectData({ ...rangeSelectData, rengeId: -1, rengeMin: 0, rengeMax: 100 });

    var dt2: RangeType[] = [];
    dt2.push({ id: 1, min: -80, max: 0, splitsCount: 4 });
    dt2.push({ id: 2, min: -100, max: 0, splitsCount: 5 });
    setdBRangeList(dt2);

    setFrequencyRengeCmd(createRengeList(dt, t));
    setdBRangeCmd(createRengeList(dt2, t));
  }, []);

  useEffect(() => {
    setRangeSelectData({ ...props.rangeSelectData });
  }, [props.rangeSelectData]);
  useEffect(() => {
    //console.debug('tyousa - useEffect - rangeSelectData', rangeSelectData);
    //props.onChangeRangeSelectDataEvent(rangeSelectData);
  }, [rangeSelectData]);

  const ChangeRRengeSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var renge = frequencyRangeList.find((item) => item.id === Number(event.target.value));
    if (renge !== undefined) {
      if (renge.id === -1) {
        renge.min = rangeSelectData.rengeMin;
        renge.max = rangeSelectData.rengeMax;
      }
      rangeSelectData.rengeId = renge.id;
      rangeSelectData.rengeMin = renge.min;
      rangeSelectData.rengeMax = renge.max;
      setRangeSelectData({ ...rangeSelectData });
      props.onChangeRangeSelectDataEvent(rangeSelectData);
    }
  };

  const ChangeBRengeSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var renge = dBRangeList.find((item) => item.id === Number(event.target.value));
    //console.debug(['tyousa ChangeBRengeSelect', renge, selectAxis]);
    if (renge !== undefined) {
      rangeSelectData.dbId = renge.id;
      rangeSelectData.dbMin = renge.min;
      rangeSelectData.dbMax = renge.max;

      setRangeSelectData({ ...rangeSelectData });
      props.onChangeRangeSelectDataEvent(rangeSelectData);
    }
  };

  /**
   * レンジ設定変更event
   * @param min
   * @param max
   * @returns
   */
  const onChangeInputRenge = (min: number, max: number) => {
    if (rangeSelectData.rengeMin === min && rangeSelectData.rengeMax === max) {
      return;
    }
    console.debug(['onChangeInputRenge', min, max, rangeSelectData]);
    if (rangeSelectData.rengeId === -1) {
      let tmp = { ...rangeSelectData, rengeMin: min, rengeMax: max };
      setRangeSelectData({ ...tmp });
      props.onChangeRangeSelectDataEvent(tmp);
    }
  };

  /**
   * Y軸レンジ変更event
   * @param min
   * @param max
   * @returns
   */
  const onChangeYRenge = (min: number, max: number) => {
    if (rangeSelectData.yMin === min && rangeSelectData.yMax === max) {
      return;
    }
    console.debug(['onChangeYRenge', min, max, rangeSelectData]);
    let tmp = { ...rangeSelectData, yMin: min, yMax: max };
    setRangeSelectData({ ...tmp });
    props.onChangeRangeSelectDataEvent(tmp);
  };

  const changeAxis = (event: React.ChangeEvent<HTMLInputElement>) => {
    //console.debug('■■■tyousa changeAxis() Start val:', event.target.value, rangeSelectData);

    setSelectAxis(event.target.value);
    let tmp = { ...rangeSelectData, selectAxis: event.target.value };
    setRangeSelectData({ ...tmp });
    props.onChangeRangeSelectDataEvent(tmp);
    //console.debug('■■■tyousa changeAxis() End');
  };

  return (
    <table className={classes.tableStyle}>
      <tbody>
        <tr>
          <td width={104}>{t('FFTComparisonChartSetting.周波数軸範囲', '周波数軸範囲：')}</td>
          <td width={104}>
            <RangeInputNumber
              textBoxWidth={'40px'}
              label={''}
              minValue={rangeSelectData.rengeMin}
              minValueLimit={0}
              maxValueLimit={login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE}
              maxValue={rangeSelectData.rengeMax}
              onChange={onChangeInputRenge}
            />
          </td>
          <td width={20}>Hz</td>
          <td></td>
        </tr>
        <tr>
          <td width={104}>{t('FFTComparisonChartSetting.グラフ縦軸範囲', 'グラフ縦軸範囲：')}</td>
          <td width={104}>
            <RangeInputNumber
              textBoxWidth={'40px'}
              label={''}
              minValue={Number(rangeSelectData.yMin.toFixed(3))}
              minValueLimit={0}
              maxValueLimit={9999}
              maxValue={Number(rangeSelectData.yMax.toFixed(3))}
              onChange={onChangeYRenge}
            />
          </td>
          <td width={20}>{rangeSelectData.yUnit}</td>
          <td></td>
        </tr>
        <tr>
          <td colSpan={4}>
            <table>
              <tbody>
                <tr>
                  <td width={60}>{t('FFTComparisonChartSetting.振動幅', '振動幅：')}</td>
                  <td width={20}>
                    <Radio
                      checked={selectAxis === 'r'}
                      onChange={changeAxis}
                      value="r"
                      inputProps={{ 'aria-label': 'R' }}
                    />
                  </td>
                  <td width={40}>{t('FFTComparisonChartSetting.リニア', 'リニア')}</td>
                  <td width={20}>
                    <Radio
                      checked={selectAxis === 'd'}
                      onChange={changeAxis}
                      value="d"
                      inputProps={{ 'aria-label': 'D' }}
                    />
                  </td>
                  <td width={30}>dB</td>
                  <td>
                    <ItemComboBox
                      label={''}
                      itemList={dBRangeCmd}
                      value={rangeSelectData.dbId}
                      labelStyle={classes.labelStyle}
                      itemBoxStyle={classes.itemBoxStyle}
                      onChangeEvent={ChangeBRengeSelect}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default FFTComparisonChartSetting;
